import type { PolicyPlanVersion } from '@praetoid/client';

export function getLatestVersionId(versions: PolicyPlanVersion[] | undefined): string | undefined {
	return versions?.find((v) => v.is_latest)?.id ?? undefined;
}
